import { useEffect } from 'react';
import { useRoutes } from 'react-router-dom';
import { useAppSelector } from '@store';
import ChartsRoutes from './routes/charts';
import StatementsRoutes from './routes/statements';
import Accounts from './routes/accounts';
import AccountsHOC from './hoc/accounts';
import ExternalAccounts from './routes/external';

import ROUTES from './routes';

export const routes = {
  path: ROUTES.ACCOUNTS,
  element: <AccountsHOC />,
  children: [
    { ...Accounts },
    { ...ChartsRoutes },
    { ...StatementsRoutes },
    { ...ExternalAccounts },
  ],
};

const AccountsRoutes = () => {
  const elements = useRoutes([{ ...routes }]);

  const { whitelabel } = useAppSelector((state) => state.root);

  useEffect(() => {
    if (whitelabel) {
      localStorage.setItem('companyName', whitelabel?.data?.value?.companyName);
    }
  }, [whitelabel]);

  return elements;
};

export default AccountsRoutes;
